/**
 * Herontwerp P5 — the fixed E.-facing strings of Oyka voor Else (OykaApp2
 * "ELSE-APP"), shared by the server module (which gates them like every
 * other string) and the client components. Positive, concrete, no
 * options, never "vergeten", never a bot (plan §1.8, ADR-009).
 */
export const ELSE_CLOSED_TITLE_NL = 'Deze pagina is voor Else.'
export const ELSE_CLOSED_BODY_NL = 'Vraag je familie om de link.'
export const ELSE_EMPTY_DAY_NL = 'Een vrije dag.'
